interface LogoProps {
  className?: string;
  variant?: 'light' | 'dark';
}

export const LOGO_LIGHT = 'https://storage.readdy-site.link/project_files/15f4e7dd-e78a-49fd-9a05-a56342ae6a80/7fffacbd-7b3c-428f-b66c-0f3f57038013_compressed_premium-visa-solutions-logo-light.webp';
export const LOGO_DARK = 'https://storage.readdy-site.link/project_files/15f4e7dd-e78a-49fd-9a05-a56342ae6a80/665eab67-4930-4b0e-b539-bee1f0247aba_compressed_premium-visa-solutions-logo-dark.webp';

export default function Logo({ className = '', variant = 'dark' }: LogoProps) {
  const src = variant === 'light' ? LOGO_LIGHT : LOGO_DARK;
  return (
    <img
      src={src}
      alt="Premium Visa Solutions"
      className={`block object-contain ${className}`}
      style={{ height: 'auto' }}
    />
  );
}